export default __webpack_public_path__ + "static/About_us_Objective_Icon3-38f5ff11d964ed72b59591c899672dee.png";